export default __webpack_public_path__ + "static/media/search.9780c795.svg";